export enum PictureTypeEnum {
  PRODUCT = 'PRODUCT',
  USER = 'USER',
  COMPANY = 'COMPANY',
}
